import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface PlayModesProps {
  onModeSelect: (mode: string) => void;
}

export const PlayModes = ({ onModeSelect }: PlayModesProps) => {
  const modes = [
    {
      id: "local",
      title: "로컬 게임",
      description: "같은 기기에서 친구들과 함께 플레이하세요",
      icon: "🎮",
    },
    {
      id: "online",
      title: "온라인 게임",
      description: "전 세계 플레이어들과 실시간으로 대결하세요",
      icon: "🌐",
    },
  ];

  return (
    <div className="w-full h-full p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2 text-center">🎮 게임 센터</h1>
        <p className="text-muted-foreground text-center mb-8">
          원하는 게임 방식을 선택하세요!
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
          {modes.map((mode) => (
            <Card
              key={mode.id}
              className="cursor-pointer hover:shadow-lg transition-shadow border hover:border-primary/50"
              onClick={() => onModeSelect(mode.id)}
            >
              <CardHeader className="text-center">
                <div className="text-6xl mb-4">{mode.icon}</div>
                <CardTitle className="text-2xl">{mode.title}</CardTitle>
                <CardDescription className="text-base">
                  {mode.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <Button size="lg" className="w-full">
                  선택하기
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
